var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "info-item",
      attrs: { id: "project__list__coordinator" },
      on: { click: _vm.showChangeCoordinator }
    },
    [
      _c(
        "span",
        {
          staticClass:
            "text-uppercase exclude-outside-click field-label cursor-pointer"
        },
        [_vm._v(_vm._s(_vm.coordinatorFieldLabel(_vm.project)))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info-bubbles exclude-outside-click" },
        [
          _vm._l(_vm.project.projectCoordinators, function(fieldValue, index) {
            return index <= 3
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.html",
                        modifiers: { hover: true, html: true }
                      }
                    ],
                    staticClass:
                      "initials badge badge-primary cursor-pointer exclude-outside-click",
                    attrs: {
                      title:
                        index < 3
                          ? fieldValue.name
                          : _vm.getTitle(_vm.project.projectCoordinators)
                    }
                  },
                  [
                    index < 3
                      ? _c("span", { staticClass: "exclude-outside-click" }, [
                          _vm._v(
                            _vm._s(_vm._f("textInitials")(fieldValue.name))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index == 3
                      ? _c("span", { staticClass: "exclude-outside-click" }, [
                          _vm._v(
                            "+" +
                              _vm._s(
                                _vm.project.projectCoordinators.length - index
                              )
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          !_vm.project.projectCoordinators
            ? _c(
                "span",
                {
                  staticClass:
                    "badge badge-gray exclude-outside-click cursor-pointer"
                },
                [_vm._v("No Coordinator")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("plus-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.addCoordinatorFlag,
                expression: "!addCoordinatorFlag"
              }
            ],
            staticClass: "tagged-contacts plus-button plus-button--small"
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.addCoordinatorFlag,
              expression: "addCoordinatorFlag"
            }
          ],
          staticClass: "add-multiselect-group"
        },
        [
          _c(
            "div",
            { staticClass: "custom-field user-field custom-multiselect" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  }
                ],
                ref: "projectListCoordinators",
                attrs: {
                  options: _vm.allUsers,
                  "show-labels": true,
                  multiple: true,
                  "allow-empty": false,
                  "open-direction": "bottom",
                  label: "name",
                  "track-by": "id"
                },
                on: {
                  close: function($event) {
                    _vm.addCoordinatorFlag = false
                  },
                  input: function($event) {
                    _vm.updateProjectFieldValue(_vm.projectCoordinatorField)
                    _vm.addCoordinatorFlag = false
                  }
                },
                model: {
                  value: _vm.project.projectCoordinators,
                  callback: function($$v) {
                    _vm.$set(_vm.project, "projectCoordinators", $$v)
                  },
                  expression: "project.projectCoordinators"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }